import { UploadData } from '../../../../store/uploadStore';
import { mapUploadTypeToMetricsEntityType } from '../../../../libs/metrics/metricUtils';
import { convertBytesToMb } from '../../../../libs/convertBytesToMb';
import { Point } from '@influxdata/influxdb-client-browser';
import { influxWriter } from '../../../../libs/metrics/InfluxWriter';

export const sendFileUploadMetrics = (
  upload: UploadData,
  sizeBytes: number,
  startTimeMs: number,
  assembleSec?: number,
  partsCnt?: number,
) => {
  const uploadTimeSec = (Date.now() - startTimeMs) / 1000;

  const sizeMb = convertBytesToMb(sizeBytes);
  const uploadSpeedMBitsPerSec = (sizeMb * 8) / uploadTimeSec;

  const point = new Point();
  point.tag('Customer', upload.upload!.customer);
  point.tag('Site', upload.upload!.site);
  point.tag('EntityType', mapUploadTypeToMetricsEntityType(upload.meta.type));

  point.floatField('sizeMb', sizeMb);
  point.floatField('uploadSpeedMBitsPerSec', uploadSpeedMBitsPerSec);
  point.floatField('uploadTimeSec', uploadTimeSec);
  if (assembleSec) {
    point.floatField('assembleSec', assembleSec);
  }
  if (partsCnt) {
    point.floatField('partsCnt', partsCnt);
  }

  influxWriter.send('UploadFile', point);
};
